<div class="authors">
  <app-page-header
    pageTitle="Authors"
    [numberOfItem]="0"
    (searchEvent)="handleSearch($event)"
    searchPlaceholder="Search by name..."
    [loading]="isLoading"
  >
    <button class="button" [routerLink]="['/add-author']" addButton>
      <img src="assets/images/add.svg" alt="+" />
      Add <span> Author</span>
    </button>
  </app-page-header>

  <div class="author__list flex-wrap">
    <ng-container *ngIf="isLoading; else authorsCard">
      <div class="author__item" *ngFor="let i of [].constructor(3)">
        <div class="author__card">
          <app-skeleton [ratio]="1 / 1" margin="0 0 10px"></app-skeleton>
          <app-skeleton
            height="15px"
            width="80%"
            margin="0 0 3px"
          ></app-skeleton>
          <app-skeleton height="10px" width="90%"></app-skeleton>
          <app-skeleton
            height="10px"
            width="70%"
            margin="0 0 8px"
          ></app-skeleton>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<ng-template #authorsCard>
  <ng-container *ngIf="authors.length > 0; else noDataFound">
    <div
      class="author__item"
      *ngFor="let author of authors; let i = index"
      inViewport
      [lastElement]="authors.length === i + 1"
      (elementIsVisible)="loadMoreIfLastIndex()"
    >
      <div class="author__card">
        <img [src]="author.profileImagePreviewUrl" />

        <h4>{{ author.name }}</h4>
        <p>
          {{ author.description }}
        </p>
        <app-action-menu
          [isOpen]="i === menuOpenIndex"
          (delete)="openDeleteAuthorModal(author.id)"
          (edit)="handleEditAuthor(author.id)"
          (outsideClick)="closeAllMenu(i)"
          (open)="openMenu(i)"
        ></app-action-menu>
      </div></div
  ></ng-container>
</ng-template>
<ng-template #noDataFound>
  <div class="author__nodata">No data found</div>
</ng-template>

<ng-container *ngIf="deleteAuthorId">
  <app-confirmation-modal
    primaryButtonText="Cancel"
    secondaryButtonText="Yes"
    message="Are you sure you want to delete this blog ?"
    caption="Delete Confirmation"
    (onPrimaryButtonClick)="cancelDelete()"
    (onSecondaryButtonClick)="deleteAuthor()"
    [secondaryButtonLoading]="deleteLoading"
  ></app-confirmation-modal>
</ng-container>
